export interface UploadPhotosDeps {
  downscale: (file: File) => Promise<Blob>;
  upload: (blob: Blob, filename: string) => Promise<unknown>;
  onProgress?: (index: number, total: number) => void;
}

/**
 * Uploads photos one at a time, in order. A single photo failing (decode or
 * network) does not abort the rest and does not throw: the referral was
 * already created, so every remaining photo still gets its shot, and the
 * caller learns how many were lost via `failed`.
 */
export async function uploadPhotos(
  files: File[],
  { downscale, upload, onProgress }: UploadPhotosDeps,
): Promise<{ failed: number }> {
  let failed = 0;
  for (let index = 0; index < files.length; index++) {
    onProgress?.(index, files.length);
    try {
      const blob = await downscale(files[index]!);
      await upload(blob, `photo-${index + 1}.jpg`);
    } catch {
      failed += 1;
    }
  }
  return { failed };
}
